function isFinished(g) {
    return !!g && !g.deleted_at && (g.status === 'won' || g.status === 'lost');
}
/**
 * The result of one day between your board and your partner's. A solved board
 * beats an unsolved one; two solves are decided by fewer guesses; equal guesses
 * (or two misses) is a draw. Either board unfinished yields `pending`.
 */
export function duelOutcome(yours, theirs) {
    if (!isFinished(yours) || !isFinished(theirs))
        return 'pending';
    const youWon = yours.status === 'won';
    const themWon = theirs.status === 'won';
    if (youWon !== themWon)
        return youWon ? 'you' : 'them';
    if (!youWon)
        return 'draw'; // both missed
    if (yours.guesses.length < theirs.guesses.length)
        return 'you';
    if (theirs.guesses.length < yours.guesses.length)
        return 'them';
    return 'draw';
}
/** Prefer a won game over a lost one, then fewer guesses — deterministic when a
 *  player has two rows for one day (two offline devices; §5's accepted trade). */
function better(a, b) {
    const aw = a.status === 'won';
    const bw = b.status === 'won';
    if (aw !== bw)
        return aw;
    if (aw && bw)
        return a.guesses.length < b.guesses.length;
    return false;
}
function indexFinished(games, playerId) {
    const byDate = new Map();
    for (const g of games) {
        if (g.deleted_at || g.created_by !== playerId)
            continue;
        if (!isFinished(g))
            continue;
        const cur = byDate.get(g.puzzle_date);
        if (!cur || better(g, cur))
            byDate.set(g.puzzle_date, g);
    }
    return byDate;
}
/**
 * The running head-to-head over every puzzle date **both** players finished.
 * A day only one person completed is not counted — the duel needs two boards —
 * so the tally is symmetric and only grows once both have played.
 */
export function headToHead(games, youId, themId) {
    const mine = indexFinished(games, youId);
    const theirs = indexFinished(games, themId);
    let you = 0;
    let them = 0;
    let draws = 0;
    for (const [date, yourGame] of mine) {
        const theirGame = theirs.get(date);
        if (!theirGame)
            continue;
        const r = duelOutcome(yourGame, theirGame);
        if (r === 'you')
            you += 1;
        else if (r === 'them')
            them += 1;
        else if (r === 'draw')
            draws += 1;
    }
    return { you, them, draws, decided: you + them + draws };
}
export function leaderOf(h) {
    if (h.you > h.them)
        return 'you';
    if (h.them > h.you)
        return 'them';
    return 'even';
}
//# sourceMappingURL=duel.js.map